import React, { useEffect, useState, useRef } from 'react';
import './form.css'
import Upload from './upload.svg'
import Video from './video.svg'
import CrossCircle from './cross-circle.svg'
import JSZip from 'jszip';
import {v4 as uuidv4} from 'uuid';

const AWS = require('aws-sdk');

const Form = () => {

  //#region States

  const [file, setFile] = useState(null);
  const [doneUpload, setDoneUpload] = useState(false);
  const [progress, setProgress] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [notAllFields, setNotAllFields] = useState(false)
  const [badEmail, setBadEmail] = useState(false) 
  const [badDate, setBadDate] = useState(false) 
  const [busy, setBusy] = useState(false)
  const [total, setTotal] = useState(0)
  const [showError, setShowError] = useState(false)
  const [noPipe, setNoPipe] = useState(false)
  const progressRef = useRef(null);
  const [percentProgress, setPercentProgress] = useState(0)

  //#endregion States

  //#region Handlers

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      handleFileChange(droppedFile, true);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileChange = (event, dropped) => {
    setDisableSubmit(false)
    let file = null;
    if (dropped === true) {
      file = event;
    } else {
      file = event.target.files[0];
    }
    setFile(file);
  };

  const handleUpload = async (event) => {
    for (let index = 0; index < 7; index++) {
      const element = event.target.form[index].value;
      if (element === '' || element.includes('|')) {
        setNotAllFields(true)
        setNoPipe(true)
        return
      } else {
        setNoPipe(false)
        if (index === 3) {
          if (isValidEmail(element)) {
            setNotAllFields(false)
            setBadEmail(false)
          } else {
            setNotAllFields(true)
            setBadEmail(true)
            return
          }
        } else if (index === 5) {
          if(isValidDate(element)) {
            setNotAllFields(false)
            setBadDate(false)
          } else {
            setNotAllFields(true)
            setBadDate(true)
            setBadEmail(false)
            return
          }
        }
        setNotAllFields(false)
        setBadEmail(false)
      }
    }

    event.preventDefault();

    setDisableSubmit(true)
    setBusy(true)

    const currentDate = new Date();

    const options = {  
      year: 'numeric', 
      month: 'long', 
      day: 'numeric',  
    };
  
    const formattedDate = currentDate.toLocaleDateString('en-US', options);

    let formData = new FormData(); 

    formData.append('artist-band-name', event.target.form[0].value)
    formData.append('music-video-title', event.target.form[1].value)
    formData.append('country', event.target.form[2].value)
    formData.append('your-email', event.target.form[3].value)
    formData.append('copyright', event.target.form[4].value)
    formData.append('release-date', event.target.form[5].value)
    
    let formDataObject = {};
    formData.forEach((value, key) => {
      formDataObject[key] = value;
    });

    let formattedMetaData = Object.entries(formDataObject).map(([key, value]) => `${key}:\t ${value}`).join('\n');

    const zip = new JSZip();

    zip.file(formattedDate + '-' + formDataObject['your-email'] + '-' + formDataObject['music-video-title']+".txt", formattedMetaData);
    zip.file(formattedDate + '-' + formDataObject['your-email'] + '-' + file.name, file);

    const zipBlob = await zip.generateAsync(
      { 
        type: 'blob', 
        compression: 'DEFLATE', 
        compressionOptions: {level: 9}
      }
    );
    
    uploadFile(
      zipBlob, 
      formattedDate + '|' + formDataObject['your-email'] + '|' + formDataObject['music-video-title'] + '|' + formDataObject['artist-band-name'] + '|' + uuidv4()
    )
  }

  //#endregion Handlers

  //#region Functions 

  function isValidDate(date) {
    // Regular expression for a more comprehensive email format check
    const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/;
    
    
    // Test the email against the regex
    return dateRegex.test(date);
  }

  function isValidEmail(email) {
    // Regular expression for a more comprehensive email format check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    // Test the email against the regex
    return emailRegex.test(email);
  }

  function uploadFile(blob, email) {
    const S3 = new AWS.S3({
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      region: process.env.REACT_APP_AWS_DEFAULT_REGION
    });

    const bucketName = 'mjams-music-videos';
    const newFileNameKey = email + '.zip'

      const params = {
        Bucket: bucketName,
        Key: newFileNameKey,
        Body: blob,
        ACL: 'public-read'
      }

      S3.upload(params, function (err, data) {
        if (err) {
          console.log('Error', err);
          setShowError(true)
          setDisableSubmit(true)
        }
        if (data) {
          setDoneUpload(true)
        }
      }).on('httpUploadProgress', function (progressEvent) {
        setProgress(progressEvent.loaded)
        setTotal(progressEvent.total)
      })
  }

  //#endregion Functions

  //#region useEffects

  useEffect(() => {
    let x = (progress) / (total) * 100
    if (isNaN(x)) {
      x = 0
    }
    if (x > 99.3) {
      x = 100
    }
    setPercentProgress(Math.ceil(x * 1000) / 1000)

    if (progressRef.current) {
      progressRef.current.style.width = `${x}%`
    }

    return () => {

    }
  }, [progress, total, progressRef])

  //#endregion useEffects

  return (
    <div>
      <div className="container-3 w-container">
        <div className="div-block-12">
          <div className="form-block w-form">
            <form id="wf-form-New-Video-upload---[mJams-with-Upload]-New-Video---new-submission" name="wf-form-New-Video-upload---[mJams-with-Upload]-New-Video---new-submission" data-name="New Video upload - [mJams with Upload] New-Video - new submission" method="get" data-wf-page-id="6512bf33e465781a164a61d4" data-wf-element-id="33dd72ab-509a-6d1b-2a28-40f931325ea9">
              <div>
                <div className="div-block-19">
                  <h1 className="h1">Music Video Upload Form</h1><label htmlFor="Artist-Band-Name" className="caption">Artist/ Band Name</label><input type="text" className="text-field w-input" maxLength="256" name="artist-band-name" data-name="Artist/ Band Name" placeholder="Artist/ Band Name" id="Artist-Band-Name" required /><label htmlFor="Music-Video-Title-2" className="caption">Music Video Title</label><input type="text" className="text-field w-input" maxLength="256" name="music-video-title" data-name="Music Video Title 2" placeholder="Music Video Title" id="Music-Video-Title-2" required />
                  <div className="w-row">
                    <div className="column-2 w-col w-col-6">
                      <div className="div-block-13"><label htmlFor="Country-2" className="caption">Country</label><select id="Country-2" name="country" data-name="Country 2" required className="text-field w-select">
                        <option value="Papua New Guinea">Papua New Guinea</option>
                        <option value="Tonga">Tonga</option>
                        <option value="American Somoa">American Somoa</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Samoa">Samoa</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="New Caledonia">New Caledonia</option>
                      </select></div>
                    </div>
                    <div className="column-3 w-col w-col-6"><label htmlFor="Your-Email-2" className="caption">Your Email</label><input type="email" className="text-field w-input" maxLength="256" name="your-email" data-name="Your Email 2" placeholder="Your Email" id="Your-Email-2" required /></div>
                  </div>
                  <div className="w-row">
                    <div className="column-2 w-col w-col-6">
                      <div className="div-block-13"><label htmlFor="Copyright-2" className="caption">Copyright</label><input type="text" className="text-field w-input" maxLength="256" name="copyright" data-name="Copyright 2" placeholder="Copyright" id="Copyright-2" required /></div>
                    </div>
                    <div className="column-3 w-col w-col-6"><label htmlFor="Release-Date" className="caption">Release Date (Separate with: <strong>/</strong>)</label><input type="string" className="text-field w-input" maxLength="256" name="release-date" data-name="Release Date" placeholder="DD/MM/YYYY" id="Release-Date" required /></div>
                  </div>
                  <div className="w-row">
                    <div className="column-2 w-col w-col-6"></div>
                    <div className="column-3 w-col w-col-6"></div>
                  </div>
                  <div className="w-row">
                    <div className="column-2 w-col w-col-6"></div>
                    <div className="column-3 w-col w-col-6"></div>
                  </div>
                  <h5 className="h5">Upload</h5>
                  <div
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    className={!busy ? 'dropzone' : 
                                       doneUpload ? 'dropzone green-bg' : 'dropzone orange-bg'
                              }
                  >
                    {file ? (
                      <div className='has-file'>
                        <div>Uploading media</div>
                        {!doneUpload && <div className="p overline upload-hint">Stay here until the upload is done. Don't close or go away. It might take some time. Make sure your internet is strong, and you've got enough data.</div>}
                        {doneUpload && <div className="p overline upload-hint">All done! 🎉</div>}
                        <div className='transcode-container'>
                          <div className='info-container'>
                            <img src={Video} alt='video file icon'></img>
                            <div className="stack">
                              <div>{file.name}</div>
                              <div className='progress'>
                                <div>{percentProgress}%</div>
                              </div>
                            </div>
                            <div className='remove-video-container'>
                              <label htmlFor="remove-video">Cancel</label>
                              <img name='remove-video' className='remove-video' onClick={() => { setFile(null); window.location.reload() }} src={CrossCircle} alt='Cancel upload' />
                            </div>
                          </div>
                          <div id="myProgress">
                            <div ref={progressRef} id="myBar"></div>
                          </div>

                        </div>
                      </div>
                    ) : (
                      <>
                        <img className="upload-icon" src={Upload} alt='Upload Icon' />
                        <label htmlFor="fileInput" className='file-label' style={{ cursor: 'pointer' }}>
                          Drag & Drop or <input type="file" onChange={handleFileChange} className="file-upload-input" accept="*" name="music-video" data-name="Music Video" aria-hidden="true" id="Music-Video" required />
                          <div className="w-icon-file-upload-icon"></div>
                          then click SUBMIT.
                        </label>
                        <p className='permissions'>Correct Permissions for all media</p>
                      </>
                    )}

                    <div>
                      <div className="w-file-upload">
                        <div className="default-state-2 w-file-upload-default">

                        </div>
                        <div tabIndex="-1" className="w-file-upload-success w-hidden">
                          <div className="w-file-upload-file">
                            <div aria-label="Remove file" role="button" tabIndex="0" className="w-file-remove-link">
                              <div className="w-icon-file-upload-remove"></div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                  </div>
                  <div className="p bold">Once all fields have been completed - press the button below to submit your video.</div>
                  {notAllFields && <div className="p bold red-text">Please fill in ALL fields.</div>}
                  {badEmail && <div className="p bold red-text">Please enter a valid email address.</div>}
                  {badDate && <div className="p bold red-text"><pre>Please enter date as <strong>DD/MM/YYYY</strong> - This means (DAY/MONTH/YEAR) </pre></div>}
                  {noPipe && <div className="p bold red-text">Please do not use the pipe character (|) in any of the fields.</div>}
                  {showError && <div className="p bold red-text">There was an error uploading your video. Please try again.</div>}
                  {busy && doneUpload ? <input type="button" onClick={()=>{window.location.reload()}} value="Upload another video" className="button-primary button w-button" /> : <input type="button" onClick={handleUpload} disabled={disableSubmit} value="Submit Media" data-wait="Please wait..." className= {!disableSubmit ? "button-primary button w-button submit-pulse" : "button-primary button w-button busy-gray"} />}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Form
